/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AbteilungDto } from '../../models/abteilung-dto';

export interface GetAbteilungen$Plain$Params {
}

export function getAbteilungen$Plain(http: HttpClient, rootUrl: string, params?: GetAbteilungen$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AbteilungDto>>> {
  const rb = new RequestBuilder(rootUrl, getAbteilungen$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AbteilungDto>>;
    })
  );
}

getAbteilungen$Plain.PATH = '/v1/abteilungen';
